/**
 * Social Fee Rate Mapping Enum
 * Maps backend social fee rate deduction values to display percentages
 */
export enum SocialFeeRateMapping {
  LOW_RATE = 9.26,
  LOW_RATE_DISPLAY = 10.21,
  HIGH_RATE = 23.91,
  HIGH_RATE_DISPLAY = 31.42,
  ZERO_RATE = 0,
  ZERO_RATE_DISPLAY = 0
}

/**
 * Maps social fee rate deduction to display percentage
 * @param socialFeeRateDeduction - The backend social fee rate deduction value
 * @returns The display percentage to show in UI
 */
export const getSocialFeeDisplayRate = (socialFeeRateDeduction: number): number => {
  const rate = Number(socialFeeRateDeduction);
  
  // Check for exact match or close approximation (within 0.01 tolerance)
  if (Math.abs(rate - SocialFeeRateMapping.LOW_RATE) < 0.01) {
    return SocialFeeRateMapping.LOW_RATE_DISPLAY;
  }
  
  if (Math.abs(rate - SocialFeeRateMapping.HIGH_RATE) < 0.01) {
    return SocialFeeRateMapping.HIGH_RATE_DISPLAY;
  }
  
  if (rate === SocialFeeRateMapping.ZERO_RATE) {
    return SocialFeeRateMapping.ZERO_RATE_DISPLAY;
  }
  
  // Return original value if no mapping found
  return rate;
};
